import React, { useContext, useState, useEffect } from "react"
import { createClient } from 'contentful';
import SectionHeader from "../components/SectionHeader"
import Layout from "../components/layout"
import tw, { styled, css } from "twin.macro"
import newsBg from "../images/news_bg.jpg"
import { graphql } from "gatsby"
import { StaticImage, GatsbyImage } from "gatsby-plugin-image"
import { FaInstagram } from "react-icons/fa"
import { motion } from "framer-motion"
import { InView } from "react-intersection-observer"
import { Link, useTranslation, Trans, I18nextContext } from "gatsby-plugin-react-i18next"
import people from '../images/en/studio.json'
import { Helmet } from "react-helmet";


export const query = graphql`
  query ($language: String!) {
    locales: allLocale(filter: {ns: {in: ["studio"]}, language: {eq: $language}}) {
      edges {
        node {
          ns
          data
          language
        }
      }
    }
  }
`;

const client = createClient({
  space: 't4z33uwt11dv',
  accessToken: 'NAJ_xsjTxvdD8zMWBCWTp_xcJeviEHM3G16MA_fn4e8'
});

const Studio = () => {
  const [entries, setEntries] = useState(null);
  const context = useContext(I18nextContext);
  const { t } = useTranslation();

  useEffect(() => {
    client.getEntries(
      { locale: context.language === 'pl' ? 'pl' : 'en-US', }
    )
      .then((entry) => {
        console.log(entry);
        const items = entry.items.filter((item) => !item.fields.portfolio);
        setEntries(
          items.sort((a, b) => a.fields.order - b.fields.order)
            .map((item) => {
              return {
                name: item.fields.name,
                description: item.fields.description,
                image: item.fields.image.fields.file.url,
                jobTitle: item.fields.jobTitle,
                ig: item.fields.instagram
              }
            })
        )
      })
      .catch(console.error);
  }, []);

  return (
    <Layout>
      <Helmet>
        <title>O nas. Historia założenia salonu - Tattoo Studio Nemezink</title>
        <meta name="description" content="Poznaj historię założenia naszego wyjątkowego i niepowtarzalnego studia tatuażu Nemezink oraz nasz zespół artystów. Zapraszamy do sprawdzenia!" />
      </Helmet>
      <StudioSection>
        <div tw="flex flex-col items-start">
          <StaticImage
            src="../images/about_us_fist.png"
            alt="założyciele salonu tatuażu nemezink"
            loading="eager"
            quality={30}
            css={css`
              width: 41vw;
              height: 32vw;
              margin-bottom: 3vw;
              @media (max-width: 1024px) {
                width: 90%;
                height: 64vw;
                margin: 3vw 0vw 6vw 0vw;
              }
            `}
          />
          <motion.div
            initial={{ x: "-50%", opacity: 0 }}
            animate={{ x: "0%", opacity: 1 }}
            transition={{ duration: 0.6, ease: "easeOut" }}
          >
            <AboutStudioText>
              <Subtitle><Trans>artistsHeader</Trans></Subtitle>
              <Trans>artistsDesc</Trans>
              <br />
              <br />
              <Link to="/tattoo"><b tw="hover:underline"><Trans>artistsBtn</Trans></b></Link>
            </AboutStudioText>
            <StaticImage
              src="../images/tattooProcess.jpg"
              quality={30}
              alt="wykonywanie tatuażu klientce w salonie tatuażu nemezink"
              css={css`
                width: 36vw;
                height: 24vw;
                margin-top: 3vw;
              `}
            />
          </motion.div>
        </div>
        <div tw="flex flex-col items-start">
          <motion.div
            initial={{ x: "75%", opacity: 0 }}
            animate={{ x: "0%", opacity: 1 }}
            transition={{ duration: 0.6, ease: "easeOut" }}
          >
            <SectionHeader
              size="md"
              tag={<Trans>studioTag</Trans>}
              text={<Trans>studioHeader</Trans>}
              emphasizedText={<Trans>studioHeaderSub</Trans>}
              emphasizedTag="h1"
            />
          </motion.div>
          <motion.div
            tw="inline-block"
            initial={{ y: "25%", opacity: 0 }}
            animate={{ y: "0%", opacity: 1 }}
            transition={{ duration: 0.6, ease: "easeOut" }}
          >
            <AboutStudioText tw="ml-0">
              <Trans>studioDesc</Trans>
            </AboutStudioText>
            <motion.div tw="relative">
              <StaticImage
                src="../images/designing.jpg"
                quality={30}
                alt="tatuażystki omawiają projekt tatuażu"
                css={css`
                  ${tw`relative`}
                  width: 36vw;
                  height: 39vw;
                  margin-top: 3vw;
                  @media (max-width: 1024px) {
                    width: 85%;
                    height: 75vw;
                    z-index: 1;
                  }
                `}
              />
              <InView rootMargin="-20% 0%" triggerOnce={true}>
                {({ ref, inView }) => (
                  <Details
                    ref={ref}
                    animate={{
                      opacity: inView ? 1 : 0,
                    }}
                    transition={{
                      duration: 0.4,
                      ease: "easeIn",
                    }}
                  >
                    <DetailsHeader><Trans>visitUsHeader</Trans></DetailsHeader>
                    <p>
                      <Trans>visitUsDesc</Trans>
                    </p>
                  </Details>
                )}
              </InView>
            </motion.div>
          </motion.div>
        </div>
      </StudioSection>
      <MobileStudioSection>
        <SectionHeader
          tag={<Trans>studioTag</Trans>}
          text={<Trans>studioHeader</Trans>}
          emphasizedText={<Trans>studioHeaderSub</Trans>}
          emphasizedTag="h1"
        />

        <StaticImage
          src="../images/about_us_fist.png"
          alt="założyciele salonu tatuażu nemezink"
          loading="eager"
          quality={30}
          css={css`
            width: 41vw;
            height: 32vw;
            margin-bottom: 3vw;
            @media (max-width: 1024px) {
              width: 80vw;
              height: auto;
              margin: 3vw 0vw 6vw 0vw;
            }
            @media (max-width: 760px) {
              width: 100%;
              height: 65vw;
              margin: 3vw 0vw 6vw 0vw;
            }
          `}
        />
        <MobileText>
          <Trans>studioDesc</Trans>
        </MobileText>
        <MobileDivider />
        <StaticImage
          src="../images/designing.jpg"
          quality={30}
          alt="tatuażystki omawiają projekt tatuażu"
          css={css`
            ${tw`relative`}
            width: 36vw;
            height: 39vw;
            margin-top: 3vw;
            @media (max-width: 1024px) {
              width: 70vw;
              height: 68vw;
              z-index: 1;
            }
            @media (max-width: 760px) {
              width: 85%;
              height: 75vw;
              z-index: 1;
            }
          `}
        />
        <Details>
          <DetailsHeader><Trans>visitUsHeader</Trans></DetailsHeader>
          <span>
            <Trans>visitUsDesc</Trans>
          </span>
        </Details>
        <MobileSubtitle><Trans>artistsHeader</Trans></MobileSubtitle>
        <MobileText style={{ marginBottom: "0vw" }}>
          <Trans>artistsDesc</Trans>
          <br />
          <br />
          <Link to="/tattoo"><b tw="hover:underline"><Trans>artistsBtn</Trans></b></Link>
        </MobileText>
      </MobileStudioSection>
      <MobileTeamSection>

        <SectionHeader
          tag={<Trans>teamTag</Trans>}
          text={<Trans>teamHeader</Trans>}
          emphasizedText={<Trans>teamHeaderSub</Trans>}
          emphasizedTag="h2"
        />
        {entries && entries.map((e, i) =>
          <TeamMemberMobile
            role={e.jobTitle}
            name={e.name}
            link={e.instagram}
            description={e.description}
          >
            <Link to="/tattoo" state={{ artist: "Natalia" }}>
              <img
                src={e.image}
                alt="nemezink team member"
                css={css`
                  width: 20vw; // Fixed width
                  height: 26vw; // Fixed height to standardize the size across all images
                  object-fit: cover; // Cover the area, cropping the image if necessary
                  @media (max-width: 1024px) {
                    ${tw`self-center w-full`}
                    width: 90vw; // Adjust width for smaller screens
                    height: 90vw; // Adjust height to maintain a consistent size ratio
                    margin-top: 10vw;
                  }
                `}
              />
            </Link>
          </TeamMemberMobile>

        )}

      </MobileTeamSection>
      <TeamSection>
        <div tw="flex flex-col justify-start items-end last:mb-0">
          <motion.div>
            <SectionHeader
              tag={<Trans>teamTag</Trans>}
              text={<Trans>teamHeader</Trans>}
              emphasizedText={<Trans>teamHeaderSub</Trans>}
              size="md"
              emphasizedTag="h2"
            />
          </motion.div>
          {entries && entries.map((e, i) => {
            if (i % 2 !== 0) {
              return (<TeamMember
                align="left"
                role={e.jobTitle}
                name={e.name}
                link={e.instagram}
                description={e.description}
              >
                <Link to="/tattoo" state={{ artist: "Natalia" }}>
                  <img
                    src={e.image}
                    alt="natalia tattoo artist"
                    css={css`
                      width: 20vw;
                      height: 26vw; // Preset height to maintain the aspect ratio
                      object-fit: cover; // Ensure the content is covered without distortion
                      cursor: pointer;
                      @media (max-width: 1024px) {
                        ${tw`self-center w-full`}
                        width: 90vw; // Adjust width for smaller screens
                        height: 90vw; // Adjust height to maintain aspect ratio on smaller screens
                        margin-top: 10vw;
                      }
                    `}
                  />
                </Link>
              </TeamMember>)
            }
          })}
        </div>
        <div dw="flex flex-col">
          {entries && entries.map((e, i) => {
            if (i % 2 === 0) {
              return (<TeamMember
                align="right"
                role={e.jobTitle}
                name={e.name}
                link={e.instagram}
                description={e.description}
              >
                <Link to="/tattoo" state={{ artist: "Natalia" }}>
                  <img
                    src={e.image}
                    alt="natalia tattoo artist"
                    css={css`
                      width: 20vw;
                      height: 26vw; // Preset height to maintain the aspect ratio
                      object-fit: cover; // Ensure the content is covered without distortion
                      cursor: pointer;
                      @media (max-width: 1024px) {
                        ${tw`self-center w-full`}
                        width: 90vw; // Adjust width for smaller screens
                        height: 90vw; // Adjust height to maintain aspect ratio on smaller screens
                        margin-top: 10vw;
                      }
                    `}
                  />
                </Link>
              </TeamMember>)
            }
          })}

        </div>
      </TeamSection>
    </Layout>
  )
}

export default Studio

const TeamMember = ({ name, role, ig, align, link, children, description }) => {
  return (
    <InView rootMargin="20%" triggerOnce={true}>
      {({ ref, inView }) => (
        <Wrapper
          align={align}
          ref={ref}
          animate={{ y: inView ? "0%" : "50%", opacity: inView ? 1 : 0 }}
          transition={{ duration: 0.6, ease: "easeOut" }}
        >
          <Member align={align}>
            <MemberRole>{role}</MemberRole>
            <MemberName>{name}</MemberName>
            <MemberDescription align={align}>{description}</MemberDescription>
          </Member>
          <div tw="relative">
            {link && link.length ?
              <a href={link} alt="nemezink member instagram">
                <IgIcon align={align} />
              </a> :
              <></>
            }
            {children}
          </div>
        </Wrapper>
      )}
    </InView>
  )
}

const TeamMemberMobile = ({ name, role, link, children, description }) => {
  return (
    <TeamMemberContainer tw="flex flex-col items-start w-11/12">
      <div tw="relative w-full">
        {children}
        {link && link.length ?
          <a href={link} alt="nemezink member instagram">
            <IgIcon />
          </a> :
          <></>
        }
      </div>
      <MemberName>{name}</MemberName>
      <MemberRole>{role}</MemberRole>
      <MobileText>{description}</MobileText>
    </TeamMemberContainer>
  )
}

const TeamMemberContainer = styled.div`
  ${tw`flex flex-col items-start w-11/12`}
  @media(max-width: 1024px) {
    width: 72vw;
  }
  @media (max-width: 760px) {
    ${tw`w-11/12`}
  }
`

const MemberDescription = styled.p`
  font-family: "Space Mono";
  font-size: 0.8vw;
  color: #e7e7e7;
  text-align: ${({ align }) => (align === "left" ? "left" : "right")};
  max-width: 17vw;
  margin-bottom: 0.5vw;
`

const MobileText = styled.p`
  max-width: 100%;
  font-family: "Space Mono";
  font-size: 2.5vw;
  color: #e7e7e7;
  margin: 1vw 0vw 0vw 0vw;
  @media (max-width: 760px) {
    font-size: 3.5vw;
    margin: 2vw 0vw 0vw 0vw;
  }
`

const Subtitle = styled.h6`
  font-family: "Merriweather";
  text-align: left;
  color: #e7e7e7;
  font-size: 1.6vw;
`

const MobileSubtitle = styled.h6`
  font-family: "Merriweather";
  font-size: 3vw;
  color: #e7e7e7;
  text-align: left;
  align-self: flex-start;
  margin-bottom: 2vw;
  @media (max-width: 760px) {
    font-size: 4.4vw;
  }
`

const Wrapper = styled(motion.div)`
  ${tw`flex justify-center items-center`}
  flex-direction: ${({ align }) =>
    align === "left" ? "flex-row" : align === "right" ? "row-reverse" : null};

  margin-bottom: 5.4vw;
  ${({ align }) =>
    align === "left"
      ? "margin-right: 2.7vw;"
      : align === "right"
        ? "margin-left: 2.7vw;"
        : null};
`

const Member = styled.div`
  ${tw`flex flex-col`}
  border-bottom: 1px solid #fbfbfb;
  width: 18vw;
  align-items: ${({ align }) =>
    align === "right" ? "flex-end" : align === "left" ? "flex-start" : null};
`

const MemberRole = styled.span`
  font-family: "Space Mono";
  font-size: 0.8vw;
  text-decoration: uppercase;
  letter-spacing: 0.1em;
  color: rgba(251, 251, 251, 0.65);
  @media (max-width: 1024px) {
    font-size: 2.5vw;
  }
  @media (max-width: 760px) {
    font-size: 3.4vw;
  }
`

const MemberName = styled.span`
  font-family: "Merriweather";
  font-size: 1.6vw;
  color: #e7e7e7;
  margin: 0.2vw 0vw;
  @media (max-width: 1024px) {
    font-size: 4vw;
    margin-top: 2vw;
  }
  @media (max-width: 760px) {
    font-size: 5.2vw;
    margin-top: 2vw;
  }
`

const IgIcon = styled(FaInstagram)`
  ${tw`absolute`}
  font-size: 2.6vw;
  color: #e7e7e7;
  bottom: 0.6vw;
  z-index: 10;
  ${({ align }) => (align === "left" ? "left: 0.6vw" : "right: 0.6vw")};
  @media (max-width: 1024px) {
    ${tw`absolute`}
    top: 12vw;
    right: 2vw;
    font-size: 8vw;
  }
  @media (max-width: 760px) {
    ${tw`absolute`}
    top: 12vw;
    right: 2vw;
    font-size: 10vw;
  }
`

const StudioSection = styled.div`
  ${tw`relative flex flex-row justify-between overflow-hidden bg-fixed`}
  line-height: 1.5 !important;
  background-image: url(${newsBg});
  background-size: cover;
  background-repeat: no-repeat;
  padding: 9.5vw 7vw 6vw 7vw;
  @media (max-width: 1024px) {
    display: none;
    background-attachment: initial;
  }
`

const MobileStudioSection = styled.div`
  ${tw`relative flex-col items-center bg-fixed`}
  display:none;
  background-image: url(${newsBg});
  background-size: cover;
  background-repeat: no-repeat;
  padding: 25vw 5vw 7.5vw 5vw;
  @media (max-width: 1024px) {
    text-align: left;
    display: flex;
    background-attachment: initial;
  }
`

const AboutStudioText = styled.div`
  font-family: "Space Mono";
  color: #e7e7e7;
  font-size: 1.1vw;
  margin-left: 1.4vw;
  max-width: 33vw;
  margin-bottom: 2vw;
  @media (max-width: 1024px) {
    max-width: 100%;
    font-size: 3.4vw;
    margin: 0px;
    margin-top: 2vw;
  }
`

const MobileDivider = styled.div`
  ${tw`w-full`}
  height: 1px;
  background-color: #e7e7e7;
  margin: 8vw 0vw 6vw 0vw;
`
const Details = styled(motion.div)`
  ${tw`absolute bottom-0 left-0 flex flex-col z-30`}
  padding: 1vw 1vw 0.5vw 2vw;
  font-family: "Space Mono";
  font-size: 0.95vw;
  color: rgba(251, 251, 251, 0.85);
  background-color: #111111;
  z-index: 10;
  max-width: 40vw;
  transform: translate(-3vw, 8vw);
  @media (max-width: 1024px) {
    ${tw`relative z-30`}
    padding: 3vw 3vw 3vw 3vw;
    z-index: 20;
    font-size: 2.5vw;
    width: 90%;
    max-width: 100%;
    transform: none;
    margin-top: -10vw;
    margin-bottom: 8vw;
  }
  @media (max-width: 760px) {
    ${tw`relative z-30`}
    padding: 3vw 3vw 3vw 3vw;
    z-index: 20;
    font-size: 3.5vw;
    width: 95%;
    max-width: 100%;
    transform: none;
    margin-top: -10vw;
    margin-bottom: 8vw;
  }
`

const DetailsHeader = styled.span`
  ${tw`relative z-30`}
  font-family: "Merriweather";
  font-size: 1.5vw;
  color: #e7e7e7;
  padding-bottom: 1vw;
  @media (max-width: 1024px) {
    font-size: 3vw;
    padding-bottom: 2vw;
  }
  @media (max-width: 760px) {
    font-size: 4vw;
  }
`

const TeamSection = styled.div`
  ${tw`flex flex-row items-start justify-center w-full`}
  padding: 6vw 7vw 0.8vw 7vw;
  background-color: #171717;
  @media (max-width: 1024px) {
    display: none;
  }
`

const MobileTeamSection = styled.div`
  ${tw`flex-col items-center`}
  display:none;
  padding: 7.5vw 5vw 7.5vw 5vw;
  background-color: #171717;
  @media (max-width: 1024px) {
    display: flex;
    padding: 7.5vw 5vw 7.5vw 5vw;
  }
  @media (max-width: 760px) {
    display: flex;
    padding: 10vw 4vw 10vw 4vw;
  }
`
